// extracted by mini-css-extract-plugin
module.exports = {"form":"DependentModal_form__1n7SG","white":"DependentModal_white__t6R_Z","resetDelete":"DependentModal_resetDelete__EIoX-"};